import { render } from "./ImportationUsagerPage.vue?vue&type=template&id=b75169b2&ts=true"
import script from "./ImportationUsagerPage.vue?vue&type=script&lang=ts"
export * from "./ImportationUsagerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__